// 404.js
import Layout from "../components/layouts/main";
import classnames from "classnames";
import React from "react";
import styles from "../styles/page-error.module.scss";

export default function FourOhFour() {
  return (
    <Layout
      article={null}
      seoTitle="Trang không được tìm thấy"
      seoDescription="Chia sẻ kinh nghiệm quản lý và bán hàng hợp kênh thiết thực nhất"
      canonical="404"
    >
      <div id="wrapper" className={classnames(styles["page-404"], "main-content")}>
        <div className={classnames(styles["post-content"])}>
          <div className="container">
            <div className="row">
              <div className="col-xl-5 order-xl-2">
                <div className={classnames(styles["block-img"])}>
                  <img src="https://www.sapo.vn/Themes/Portal/Default/Images/404_background.png" alt="Không tìm thấy trang" className="fade show" />
                </div>
              </div>
              <div className="col-xl-7 order-xl-1">
                <div className="text-center">
                  <h1>Trang không được tìm thấy</h1>
                  <p>
                    Thật tiếc! Trang của bạn yêu cầu không tồn tại. <br className="d-none d-md-block" />
                    Vui lòng thử với một trang khác hoặc liên hệ trực tiếp với Sapo nhé!
                  </p>
                </div>
                <div className="row">
                  <div className={classnames(styles["item"], "col-md-4")}>
                    <i className={styles["icon1"]}></i>
                    <div>
                      <a href="https://www.sapo.vn/blog">Sapo Blog</a>
                      <span>Chia sẻ kinh nghiệm quản lý và bán hàng hợp kênh thiết thực nhất</span>
                    </div>
                  </div>
                  <div className={classnames(styles["item"], "col-md-4")}>
                    <i className={styles["icon2"]}></i>
                    <div>
                      <a href="https://www.sapo.vn/bang-gia.html">Bảng giá dịch vụ</a>
                      <span>
                        Thông tin chi tiết về các <br className="d-none d-md-block" />
                        gói dịch vụ của Sapo
                      </span>
                    </div>
                  </div>
                  <div className={classnames(styles["item"], "col-md-4")}>
                    <i className={styles["icon3"]}></i>
                    <div>
                      <a href="https://www.sapo.vn/lien-he.html">Liên hệ với Sapo</a>
                      <span>
                        Tổng đài tư vấn dịch vụ: <a href="tel:1900 6750">1900 6750</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
